'use client';

// NO 'use client'. This is an async Server Component.
import ShopByConcernSlider from './ShopByConcernSlider'; // Direct import of the client component
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import ShopByConcernSkeleton from './ShopByConcernSkeleton';
import { API_HOME_THINGS } from '@/constant/apiRout';
// This component is now async and fetches its own data
const ShopByConcern = () => {
  // ✅ THIS IS HOW YOU GET THE DATA
  // Assuming the data comes from the 'home-things' endpoint

  const { data: homeThings, isLoading } = useFetcherCSR(API_HOME_THINGS);

  if (isLoading) return <ShopByConcernSkeleton />;
  const concerns = homeThings?.skin_concern ?? [];

  // If there's no data, don't render the section
  if (concerns.length === 0) {
    return null;
  }

  return (
    // REMOVED the data-aos attribute for better performance
    <section className="featured-categories padding-bottom">
      <div className="container">
        <div className="concern">
          {/* This header is now static HTML from the server, which is much faster */}
          <div className="section-header">
            <div className="section-header__content justify-content-sm-center w-100">
              <h2 className="margin-top-10">Shop By Concern</h2>
            </div>
          </div>
          {/* Pass the server-fetched data to the client slider */}
          <ShopByConcernSlider concerns={concerns} />
        </div>
      </div>
    </section>
  );
};

export default ShopByConcern;
